/* alphanum.js (C) Brian Huisman
 * Based on the Alphanum Algorithm by David Koelle
 * The Alphanum Algorithm is discussed at http://www.DaveKoelle.com
 *
 * Distributed under same license as original
 *
 * Released under the MIT License - https://opensource.org/licenses/MIT
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import { Obj } from "../models/obj";

function alphanum(a: string, b: string) {
    function chunkify(t: string): number[] {
        let tz = new Array();
        let n = null
        let x = 0, y = -1, i, j;

        while (i = (j = t.charAt(x++)).charCodeAt(0)) {
            let m = (i == 46 || (i >= 48 && i <= 57));
            if (m != n) {
                tz[++y] = "";
                n = m;
            }
            tz[y] += j;
        }
        return tz;
    }

    let aa = chunkify(a?.toLowerCase() || "");
    let bb = chunkify(b?.toLowerCase() || "");

    for (let x = 0; aa[x] && bb[x]; x++) {
        if (aa[x] !== bb[x]) {
            let c = Number(aa[x]), d = Number(bb[x]);
            if (c == aa[x] && d == bb[x]) {
                return c - d;
            } else return (aa[x] > bb[x]) ? 1 : -1;
        }
    }
    return aa.length - bb.length;
}
export const sortDates = (a: Date, b: Date) => {
    return a.getTime() - b.getTime()
}

const toString = (val: any): string => {
    if (typeof val == "string") {
        return val
    }
    return JSON.stringify(val) || ""
}

export const createAlphanumSortObjects = (key: string, date?: boolean) => {

    return (objA: Obj, objB: Obj) => {
        if (date) {
            // convert them to ms
            const a = new Date(objA[key])
            const b = new Date(objB[key]);
            return sortDates(a, b)
        } else if (typeof (objA[key]) === "number" && typeof (objB[key]) === "number") {
            return objA[key] - objB[key];
        }
        else {
            const a = toString(objA[key])
            const b = toString(objB[key])

            return alphanum(a, b)
        }
    }
}

export default alphanum
